<div class="layout">
  @if (showNavigation()) {
    <button
      type="button"
      class="sidebar-backdrop"
      [class.is-open]="menuOpen()"
      aria-label="Navigation schließen"
      (click)="closeMenu()"
    ></button>
  }

  <aside class="sidebar" [class.sidebar-open]="menuOpen()">
    <div class="brand">
      <img class="brand-logo" src="assets/brand/dma-logo-sidebar.png" alt="DriveMe Academy">
     <!--<strong>Schulungsportal</strong> -->
    </div>

    @if (showNavigation()) {
      <nav (click)="closeMenu()">
        @if (management()) {
          <a routerLink="/dashboard" routerLinkActive="active">Dashboard</a>
          @if (superAdmin()) {
            <a routerLink="/organizations" routerLinkActive="active">Organisation</a>
          }
          @if (organizationManagement()) {
            <a routerLink="/companies" routerLinkActive="active">Unternehmer</a>
          }
          <a routerLink="/drivers" routerLinkActive="active">Fahrer</a>
          @if (courseEditor()) {
            <a routerLink="/course-videos" routerLinkActive="active">Kursvideos und Fragen</a>
          }
          <a routerLink="/certificates" routerLinkActive="active">Zertifikate</a>
          @if (superAdmin()) {
            <a routerLink="/audit-logs" routerLinkActive="active">Auditlog</a>
          }
        }

        @if (driver()) {
          <a routerLink="/learning" routerLinkActive="active">Mein Lernbereich</a>
          <a routerLink="/certificates" routerLinkActive="active">Meine Zertifikate</a>
        }
      </nav>
    }
  </aside>

  <main class="main">
    <header class="topbar">
      <div class="topbar-title">
        @if (showNavigation()) {
          <button
            type="button"
            class="menu-toggle"
            aria-label="Menü öffnen"
            [attr.aria-expanded]="menuOpen()"
            (click)="toggleMenu()"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        }
        <div>
          <span class="kicker">DriveMe Academy Schulungsportal</span>
          <strong>{{ title() }}</strong>
        </div>
      </div>

      <div class="topbar-actions">
        <button
          type="button"
          class="skin-toggle"
          [attr.aria-label]="currentSkin() === 'modern-premium' ? 'Bright Skin aktivieren' : 'Dark Skin aktivieren'"
          [attr.title]="currentSkin() === 'modern-premium' ? 'Bright Skin aktivieren' : 'Dark Skin aktivieren'"
          (click)="toggleSkin()"
        >
          @if (currentSkin() === 'modern-premium') {
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <circle cx="12" cy="12" r="4"></circle>
              <path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.65 17.65l1.42 1.42M2 12h2M20 12h2M4.93 19.07l1.42-1.42M17.65 6.35l1.42-1.42"></path>
            </svg>
          } @else {
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M20.5 15.2A8.5 8.5 0 0 1 8.8 3.5 8.5 8.5 0 1 0 20.5 15.2Z"></path>
            </svg>
          }
        </button>

        @if (showNavigation()) {
          <button type="button" class="ghost-button" (click)="logout()">Abmelden</button>
        }
      </div>
    </header>

    <section class="content">
      <router-outlet />
    </section>
  </main>
</div>
